import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const ErrorPage = () => {
    // a route loader that throws a 403 Response (no permission) is shown as "Access denied", everything else as before
    const routeError = useRouteError();
    const accessDenied = isRouteErrorResponse(routeError) && routeError.status === 403;
    const message = accessDenied ? 'Access denied' : 'Something went wrong!';
    const detail = accessDenied ? 'You do not have permission to view this page.' : 'Please try again or contact our support if the problem persists.';

    const handleRedirect = () => {
        let redirectUrl = '/';
        const userTypeCode = sessionStorage.getItem('user-type-code');

        if (userTypeCode === 'ALUMNI') {
            redirectUrl = '/alumni/dashboard';
        } else if (userTypeCode === 'STUDENT') {
            redirectUrl = '/alumni/directory';
        } else if (userTypeCode === 'SCHOOL_ADMIN') {
            redirectUrl = '/management/dashboard';
        }

        // TODO: We need to figure out a way to make the navigate work here.
        window.location.href = redirectUrl;
    };

    return (
        <div style={{ padding: '50px', textAlign: 'center' }}>
            <h1>{message}</h1>
            <p>{detail}</p>
            <p>
                <a role="button" onClick={handleRedirect}>
                    Go to Home Page
                </a>
                {/* <Link to="/alumni/onboarding">Go to Home Page</Link> */}
            </p>
        </div>
    );
};

export default ErrorPage;
